@if (articles?.length !== 0) {
  <div class="container">
    <div class="content-inner">
      @if (this.LeadTypeId === this.muster) {
        <div class="title" fiTranslation="GENERAL_TEXT_SAMPLE"></div>
      }
      @if (this.LeadTypeId === this.brochure) {
        <div class="title" fiTranslation="GENERAL_TEXT_BROCHURE"></div>
      }
      @if (this.LeadTypeId === this.ausschreibungstexte) {
        <div class="title" fiTranslation="ALT_TEXT_REQUEST_TYPE_TENDER"></div>
      }
      @if (this.LeadTypeId === this.cadDaten) {
        <div class="title" fiTranslation="ALT_TEXT_REQUEST_TYPE_CAD_DATA"></div>
      }
      @for (article of articles; track article) {
        <div class="request-container">
          <div class="request-content">
            @if (this.LeadTypeId === this.ausschreibungstexte) {
              <div class="icon">
                <img src="assets/icons/ausschreibungstexte.svg" alt="icon" class="brochure">
              </div>
            } @else {
              @if (this.LeadTypeId === this.cadDaten) {
                <div class="icon cadDaten">
                  <img src="assets/icons/dwg-blau.svg" alt="icon"
                    class="brochure">
                </div>
              } @else {
                <div class="icon">
                  <img src="assets/icons/{{this.LeadTypeId === this.muster ? 'rectangles.svg' : 'book.svg'}}" alt="icon"
                    class="brochure">
                </div>
              }
            }
            <div class="article">{{article.Article}} - {{article.Description}}</div>
          </div>
        </div>
      }
    </div>
  </div>
}
